module.exports = __webpack_public_path__ + "img/confirm_primary.5f5e964.png";